module.exports = __webpack_public_path__ + "resources/img/bg_solution_main2.1982c29038a84071c46c6ea67f437c19.png";